import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (!from.meta.noKeepAlive) {
        from.meta.savedPosition = window.scrollY
      }

      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  },
  routes,
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js